import { useEffect, useRef, useState } from "react";
import { api } from "../../../hooks/apiClient";

const APP_ID = process.env.REACT_APP_META_APP_ID;
const CONFIG_ID = process.env.REACT_APP_META_CONFIG_ID;

export default function ConnectWhatsApp({ storeId, onDone }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const session = useRef({}); // { waba_id, phone_number_id }

  // load SDK once
  useEffect(() => {
    if (window.FB) return;
    window.fbAsyncInit = () =>
      window.FB.init({
        appId: APP_ID,
        autoLogAppEvents: true,
        xfbml: true,
        version: "v25.0",
      });
    const s = document.createElement("script");
    s.src = "https://connect.facebook.net/en_US/sdk.js";
    s.async = true;
    document.body.appendChild(s);
  }, []);

  // Embedded Signup sends waba_id + phone_number_id as a message event
  useEffect(() => {
    const onMessage = (e) => {
      if (!/^https:\/\/(www|web)\.facebook\.com$/.test(e.origin)) return;
      try {
        const d = typeof e.data === "string" ? JSON.parse(e.data) : e.data;
        if (d.type === "WA_EMBEDDED_SIGNUP" && d.event === "FINISH") {
          session.current = d.data; // { waba_id, phone_number_id, ... }
        }
      } catch {}
    };
    window.addEventListener("message", onMessage);
    return () => window.removeEventListener("message", onMessage);
  }, []);

  const connect = () => {
    setError("");
    window.FB.login(
      (res) => {
        const code = res.authResponse?.code;
        if (!code) return; // cancelled
        setBusy(true);
        // the message event can land slightly after the callback
        setTimeout(async () => {
          try {
            const { waba_id, phone_number_id } = session.current;
            await api.post("whatsapp/onboard", {
              storeId,
              code,
              wabaId: waba_id,
              phoneNumberId: phone_number_id,
            });
            onDone?.();
          } catch (e) {
            setError(e.response?.data?.message || "Could not connect WhatsApp");
          } finally {
            setBusy(false);
          }
        }, 800);
      },
      {
        config_id: CONFIG_ID,
        response_type: "code",
        override_default_response_type: true,
        extras: { setup: {}, sessionInfoVersion: "3" },
      },
    );
  };

  return (
    <div>
      <button
        onClick={connect}
        disabled={busy}
        className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800 disabled:opacity-50"
      >
        {busy ? "Connecting…" : "Connect WhatsApp"}
      </button>
      {error && <p className="mt-2 text-sm text-red-600">{error}</p>}
    </div>
  );
}
